document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const el = event.target;
  if (el.matches('[data-localization-select]')) {
    const form = el.closest('form');
    if (form) form.submit();
  }

  if (el.matches('[data-variant-select]')) {
    const option = el.options[el.selectedIndex];
    const root = el.closest('.product__info');
    if (!root || !option) return;

    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const isAvailable = option.dataset.available === 'true';

    if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

    if (compareEl) {
      if (option.dataset.comparePrice) {
        compareEl.textContent = option.dataset.comparePrice;
        compareEl.classList.remove('is-hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('is-hidden');
      }
    }

    if (addBtn) {
      addBtn.disabled = !isAvailable;
      addBtn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }
  }
});

function initProductGallery(gallery) {
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');
  const currentEl = gallery.querySelector('[data-gallery-current]');
  if (!slides.length) return;

  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) index = 0;

  const goTo = (nextIndex) => {
    if (nextIndex < 0) nextIndex = slides.length - 1;
    if (nextIndex >= slides.length) nextIndex = 0;
    index = nextIndex;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });
    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === index);
    });
    if (currentEl) currentEl.textContent = String(index + 1);
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index)));
  });

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(index - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(index + 1));

  let touchStartX = 0;
  const viewer = gallery.querySelector('.product-gallery__viewer');
  if (viewer) {
    viewer.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    viewer.addEventListener('touchend', (event) => {
      const diff = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) < 40) return;
      if (diff < 0) goTo(index + 1);
      else goTo(index - 1);
    }, { passive: true });
  }

  goTo(index);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);

  // AutoDS and marketplace descriptions often import a generic heading that
  // duplicates the theme's own Description accordion label. Hide only that
  // redundant heading; preserve all meaningful headings in the description.
  document.querySelectorAll('.product-description-clean h1, .product-description-clean h2, .product-description-clean h3, .product-description-clean h4, .product-description-clean h5, .product-description-clean h6').forEach((heading) => {
    const label = heading.textContent.trim().toLowerCase().replace(/[:\s]+$/g, '');
    if (label === 'product description' || label === 'description') {
      heading.hidden = true;
    }
  });
});
